import { spAllFormRequest, spRosteringSettingsRequest } from "../../../../store/actions/sp.actions";
import { connect } from "react-redux";
import IncidentReporting from "./IncidentReportingSetting";
import { getSpRosteringSetting, getSpRosteringSettingLoader, spFormTemplates } from "store/selector/sp.selector";

const mapDispatchToProps = {
  fetchFormTemplate: spAllFormRequest,
  spRosteringSettingsRequest,
};

const mapStateToProps = (state) => {
  return {
    spFormTemplatesList: spFormTemplates(state),
     spRosteringSetting : getSpRosteringSetting(state),
      spRosteringSettingLoader : getSpRosteringSettingLoader(state)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IncidentReporting);
